export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen w-full flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Futuristic%20hydrogen%20energy%20and%20solar%20energy%20digital%20wave%20visualization%20on%20dark%20slate%20background%20with%20neon%20cyan%20and%20green%20glowing%20particles%20abstract%20technology%20background%20cinematic%20lighting%20high%20contrast%20dark%20theme%20futuristic%20energy%20platform%20concept%20art%208k%20quality&width=1920&height=1080&seq=hero1&orientation=landscape"
          alt="에너지 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-enerverze-bg/40 via-enerverze-bg/20 to-enerverze-bg/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-12">
          <div className="max-w-2xl">
            <p className="text-lg md:text-xl text-neon-cyan font-light tracking-wide mb-6">
              버려진 에너지에서 신재생의 가치를 찾다
            </p>

            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-neon-cyan/20 border border-neon-cyan flex items-center justify-center">
                  <i className="ri-flashlight-line text-neon-cyan"></i>
                </div>
                <div className="w-10 h-10 rounded-full bg-neon-green/20 border border-neon-green flex items-center justify-center">
                  <i className="ri-sun-line text-neon-green"></i>
                </div>
                <div className="w-10 h-10 rounded-full bg-neon-cyan/20 border border-neon-cyan flex items-center justify-center">
                  <i className="ri-windy-line text-neon-cyan"></i>
                </div>
              </div>
              <span className="text-sm text-enerverze-text">AI + Energy + Platform</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-enerverze-text leading-tight mb-2">
              미래를 향한
            </h1>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-light leading-tight mb-8">
              <span className="text-gradient-cyan">에너지 혁신</span>
            </h1>

            <a
              href="#contact"
              className="inline-flex items-center gap-3 bg-enerverze-text text-enerverze-bg px-8 py-4 rounded-full text-base font-medium hover:bg-neon-cyan transition-colors group whitespace-nowrap"
            >
              <span>문의하기</span>
              <i className="ri-arrow-right-line text-neon-cyan group-hover:text-enerverze-bg transition-colors"></i>
            </a>
          </div>

          <div className="max-w-md lg:text-right">
            <p className="text-lg text-enerverze-muted leading-relaxed">
              에너버즈는 인공지능과 에너지 기술의 융합을 통해
              <br className="hidden lg:block" />
              지속 가능한 미래를 설계합니다.
              <br />
              수소에너지부터 태양열, 스마트그리드까지
              <br className="hidden lg:block" />
              차세대 에너지 솔루션을 선도합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}